<template>
  <div class="changePassword">
    <welcome-image/>
    <main-preloader
        v-if="loading"
        position="fixed"
        :size="80"
        :stroke="3"
    />
    <section class="changePassword__right">
      <form class="changePassword__form">
        <div class="changePassword__line">
          <h2 class="changePassword__title">Новый пароль</h2>
        </div>

        <div class="changePassword__line">
          <label class="changePassword__textLabel">Новый пароль</label>
          <form-input v-model="newPassword" :type="showPassword ? 'text' : 'password'" autocomplete="false"/>
        </div>

        <div class="changePassword__line">
          <label class="changePassword__textLabel">Повторите пароль</label>
          <form-input v-model="confirmPassword" :type="showPassword ? 'text' : 'password'" autocomplete="false"/>
          <div class="changePassword__options">
            <check-box
                style="color: var(--cd-text-muted)"
                text="Показать пароль"
                v-model="showPassword"
            />
          </div>
        </div>

        <div class="changePassword__line">
          <action-button
              :disabled="!newPassword || !confirmPassword || loading"
              style="width: 180px"
              icon-type="arrow"
              @button-click="submitHandler"
          >
            <template #caption>Сохранить</template>
          </action-button>
        </div>
      </form>
    </section>
  </div>
</template>

<script>
import {ref} from "vue";
import {useRouter, useRoute} from "vue-router";
import {useToast} from "vue-toast-notification";
import FormInput from "@/components/ui/FormInput.vue";
import ActionButton from "@/components/ui/ActionButton.vue";
import CheckBox from "@/components/ui/CheckBox.vue";
import WelcomeImage from "@/components/shared/WelcomeImage.vue";
import MainPreloader from "@/components/shared/MainPreloader.vue";
import http from "@/tools/http-client";
import environment from "@/environment";
import {useSettingsStore} from "@/store/settings";

export default {
  name: "ChangePasswordView",
  components: {MainPreloader, WelcomeImage, CheckBox, ActionButton, FormInput},
  setup() {
    const newPassword = ref('')
    const confirmPassword = ref('')
    const showPassword = ref(false)
    const loading = ref(false)
    const router = useRouter()
    const route = useRoute()
    const toast = useToast()
    const settingsStore = useSettingsStore()

    async function submitHandler() {
      if (loading.value) return;

      if (newPassword.value !== confirmPassword.value) {
        toast.error('Пароли не совпадают');
        return;
      }
      if (newPassword.value.length < 12) {
        toast.error('Пароль должен содержать 12 или более символов');
        return;
      }

      loading.value = true;
      try {
        const resp = await http.post(environment.appConfig.baseApiUrl + 'auth/change-password', {
          new_password: newPassword.value,
          code: route.query.code,
        });
        if (resp.data?.status !== 'success') {
          toast.error(resp.data?.message || 'Ошибка при смене пароля');
          return;
        }
        await settingsStore.loadSetting();
        await router.push({name: 'HomePage'});
      } catch (e) {
        toast.error(e?.response?.data?.message || 'Ошибка при смене пароля');
      } finally {
        loading.value = false;
      }
    }

    return {newPassword, confirmPassword, showPassword, loading, submitHandler}
  }
}
</script>

<style scoped lang="scss">
.changePassword {
  display: flex;
  padding: 60px 0;
  gap: 22px;
  align-items: stretch;
  @include respond-to('md') { flex-direction: column; padding: 32px 0; }

  &__right {
    flex: 1 1 0;
    min-width: 0;
    border-radius: 20px;
    background: #2D2D30;
    padding: 34px;

    @include respond-to('sm') { padding: 20px; }
  }

  &__form {
    text-align: left;
    width: 100%;
    font-size: 14px;
    font-weight: 400;
    font-family: var(--cd-default-font);
  }

  &__title {
    font-family: var(--cd-bold-font);
    font-size: 24px;
    font-weight: 500;
    margin: 0 0 10px;
  }

  &__textLabel {
    padding: 10px 10px;
    display: block;
  }

  &__line {
    padding-bottom: 24px;
  }

  &__options {
    display: flex;
    margin-top: 10px;
  }
}
</style>
